// extracted by mini-css-extract-plugin
export default {"btn":"BackBtn_btn__8lM8Q"};